import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Button, FlexContainer, Icon, Modal, Txt } from 'components';
import { useProperty } from 'state';
import { CauseAddEdit, CauseItem } from './components';
import styles from './CausesManage.module.scss';

/**
 * PropertyInventoryScreen
 *
 * @return {JSX.Element}
 */
const CausesManage = () => {
  const property = useProperty();
  const [modalOpen, setModalOpen] = useState(null);
  const {
    data: { clauses: dataState },
  } = property;

  const handleAdd = () => setModalOpen('add');

  const handleEdit = (idx) => () => setModalOpen(idx);

  const handleDelete = (idx) => () => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      const clauses = [...property.data.clauses];
      clauses.splice(idx, 1);
      property.update({
        clauses,
      });
    }
  };

  const handleCloseModal = () => setModalOpen(null);

  return (
    <FlexContainer
      className={classNames(styles.PropertyInventoryScreen)}
      column
      flex
    >
      <FlexContainer column gap>
        {dataState?.length ? (
          <FlexContainer gap column>
            {dataState.map((item, idx) => (
              <CauseItem
                key={idx}
                value={item}
                index={idx + 1}
                onDelete={handleDelete(idx)}
                onEdit={handleEdit(idx)}
              />
            ))}
          </FlexContainer>
        ) : null}
        <FlexContainer>
          <Button big flex onClick={handleAdd}>
            <FlexContainer spaceBetween alignCenter flex>
              <Txt xx>Add Clause</Txt>
              <Icon name="plus" />
            </FlexContainer>
          </Button>
        </FlexContainer>
      </FlexContainer>
      {modalOpen !== null ? (
        <Modal
          title={`${modalOpen === 'add' ? 'Add' : 'Update'} a Clause`}
          onClose={handleCloseModal}
          showCloseButton
        >
          <CauseAddEdit
            index={modalOpen === 'add' ? null : modalOpen}
            onClose={handleCloseModal}
          />
        </Modal>
      ) : null}
    </FlexContainer>
  );
};

CausesManage.displayName = 'CausesManage';

export default observer(CausesManage);
